<template>
    <b-container v-cloak>
        <b-card class="my-4">
            <b-row>
                <b-col cols="12" md="4">
                    <b-avatar :variant="variants[user.id % variants.length]" :text="avatarText" size="144px"></b-avatar>
                </b-col>
                <b-col cols="12" md="8" class="mt-4">
                    <b-row>
                        <b-col cols="5" md="5" class="text-right"><b>Usuario: </b></b-col>
                        <b-col cols="7" md="5" class="text-left">{{ user.username }}</b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="5" md="5" class="text-right"><b>Nombre: </b></b-col>
                        <b-col cols="7" md="5" class="text-left">{{ user.name }}</b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="5" md="5" class="text-right"><b>Email: </b></b-col>
                        <b-col cols="7" md="5" class="text-left">{{ user.email }}</b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="5" md="5" class="text-right"><b>Teleéfono 1: </b></b-col>
                        <b-col cols="7" md="5" class="text-left">{{ user.phone1 }}</b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="5" md="5" class="text-right"><b>Teléfono 2: </b></b-col>
                        <b-col cols="7" md="5" class="text-left">{{ user.phone2 }}</b-col>
                    </b-row>
                    <b-row v-if="isBackOfficeUser">
                        <b-col cols="5" md="5" class="text-right"><b>Tipo de usuario: </b></b-col>
                        <b-col cols="7" md="5" class="text-left">
                            <template v-if="user.role === 'ROLE_BACK_OFFICE_USER'">Normal</template>
                            <template v-else>Administrador</template>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
import { userUrl } from '@routes';
import * as constants from '@constants';

export default {
    data() {
        return {
            user: {
                id: 0,
                name: '',
                username: '',
                email: '',
                phone1: '',
                phone2: '',
                password: '',
                role: 'ROLE_BACK_OFFICE_USER'
            },
            variants: ['primary', 'success', 'info', 'danger', 'warning']
        };
    },
    created() {
        if (this.$route.name.includes('Portal')) {
            this.userType = constants.PORTAL_USER;
        } else {
            this.userType = constants.BACK_OFFICE_USER;
        }

        this.user.id = this.$route.params.id ?? 0;

        this.loadData();
    },
    methods: {
        loadData() {
            this.axios.get(userUrl(), {
                params: {
                    id: this.$route.params.id,
                    application: this.userType
                }
            }).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    let user = response.data.user;

                    this.user.id = user.id;
                    this.user.name = user.name;
                    this.user.username = user.username;
                    this.user.email = user.email;
                    this.user.phone1 = user.phone1;
                    this.user.phone2 = user.phone2;
                }
            });
        }
    },
    computed: {
        avatarText() {
            let strings = this.user.name.split(' ');
            let initials = [];

            strings.forEach(string => {
                initials.push(string.slice(0, 1));
            });

            return initials.length > 0 ? initials.join('') : this.username.username.slice(0, 4);
        },
        isBackOfficeUser() {
            return this.userType === constants.BACK_OFFICE_USER;
        },
        isPortalUser() {
            return this.userType === constants.PORTAL_USER;
        }
    }

}
</script>

<style scoped>

</style>